import { Cloudinary } from "@cloudinary/url-gen";

export const ApiCloudinary = {
  beforeMount() {
    this.cloudName = 'innovationafrica';
  },
  computed: {
    cld() {
      return new Cloudinary({ cloud: { cloudName: this.cloudName }});
    }
  },
  methods: {
    cldImage(publicId) {
      return this.cld.image(publicId)
        .format('auto')
        .quality('auto');
    }
  }
};
